import {debug} from "@/misc/debug";
import * as mutationTypes from "@/store/mutation-types";
import { findLocalization } from "@/store/helpers";

const state = {
	/**
	 * Array of the navigationSections of the museum
	 * @type {Array}
	 */
	navigationSections: [],

	/**
	 * Will be true when there is an error fetching navigationSections from the museum
	 * @type {boolean}
	 */
	navigationSectionsError: false,

	/**
	 * Object representing the sponsors of the museum
	 * @type {Object}
	 */
	sponsor: null,

	/**
	 * Will be true when there is an error fetching the sponsors from the museum
	 * @type {boolean}
	 */
	sponsorError: false,
};

const getters = {

};

const actions = {
	/**
	 * Gets the navigationSections of the museum
	 * @param rootState
	 * @param state
	 * @param commit
	 */
	getNavigationSections: ({ rootState, state, commit }) => {
		debug.open("getNavigationSections");
		commit(mutationTypes.SET_NAVIGATION_SECTIONS_ERROR, false);

		if(rootState.museum.museum && rootState.museum.museum.navigationSections) {
			let navigationSections = [];

			for(let index in rootState.museum.museum.navigationSections) {
				let navigationSection = rootState.museum.museum.navigationSections[index];
				debug.open("NavigationSection " + navigationSection.idNavigationSection);

				navigationSection.locale = findLocalization(navigationSection);

				navigationSections.push(navigationSection);
				debug.close();
			}

			commit(mutationTypes.SET_NAVIGATION_SECTIONS, navigationSections);
			debug.log("Found " + navigationSections.length + " navigationSections");

			if(state.navigationSections.length < 1) {
				debug.log("There are no navigationSections in this museum");
				commit(mutationTypes.SET_NAVIGATION_SECTIONS_ERROR, true);
			}
		} else {
			debug.log("There are no navigationSections in this museum");
			commit(mutationTypes.SET_NAVIGATION_SECTIONS_ERROR, true);
		}
		debug.close();
	},

	/**
	 * Gets a sponsor resource given its ID
	 * @param state
	 * @param commit
	 * @param {(number|string)} idResource - The id of the resource
	 */
	findSponsors: ({ state, commit }, idResource) => {
		debug.open("findSponsors");
		commit(mutationTypes.SET_SPONSOR_ERROR, false);
		for (let navigationSection of state.navigationSections) {
			if(navigationSection.sectionType === 'SPONSORS') {

				let resource = navigationSection.resources.find(resource => +resource.idResource === +idResource);
				commit(mutationTypes.SET_SPONSOR, resource);

				if (!state.sponsor) {
					debug.log("Sponsor " + idResource + " could not be found");
					commit(mutationTypes.SET_SPONSOR_ERROR, true);
				} else {
					debug.log("Sponsor " + idResource + " found");
					state.sponsor.locale = findLocalization(state.sponsor);
				}
			}
		}
		debug.close();
	},
};

const mutations = {
	[mutationTypes.SET_NAVIGATION_SECTIONS]: (state, value) => state.navigationSections = value,
	[mutationTypes.SET_NAVIGATION_SECTIONS_ERROR]: (state, value) => state.navigationSectionsError = value,
	[mutationTypes.SET_SPONSOR]: (state, value) => state.sponsor = value,
	[mutationTypes.SET_SPONSOR_ERROR]: (state, value) => state.sponsorError = value,
};

export default {
	moduleName: 'navigationSection',
	statePropName: 'data',
	namespaced: true,

	state,
	getters,
	actions,
	mutations
};
